import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { GenericDialog } from '@app/shared/models/generic-dialog.model';
import { GenericDialogComponent } from '../generic-dialog/generic-dialog.component';
import { Router } from '@angular/router';
import { GenericDialogDosMessage } from '@app/shared/models/generic-dialog-message.model';

@Component({
  selector: 'dhl-modal-confirm-print',
  templateUrl: './modal-confirm-print.component.html',
  styleUrls: ['./modal-confirm-print.component.scss']
})
export class ModalConfirmPrintComponent {
  dialogData: GenericDialogDosMessage;
  disableButtonTerms: boolean = true;
  public checkValue = false;

  constructor(public dialogRef: MatDialogRef<GenericDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: GenericDialog, public router: Router) {
    this.dialogData = data;
  }
  /**
   * On Accept dialog generic action
   */
  onAccept(): void {
    this.dialogRef.close(true);
    void this.router.navigate(["/clients/print-guides"]).then(() => {
      // Una vez que la navegación se haya completado, ajustar la posición de desplazamiento
      window.scrollTo(0, 0);
    });
  }

  /**
   * On Cancel dialog generic action
   */
  onCancel(): void {
    this.dialogRef.close(false);
  }

}
